import { RunningCalculator } from './RunningCalculator.mjs'
import { orderedCanonicalUrlTypes } from '../Expectation/utils/canonicalUrlTools.js'

/**
 * UrlDataRc is a RunningCalculator class that calculates (URL, title) pair times
 * for a given logging session.
 *
 * It also acts as a store for MetadataEvent key/value pairs for a given URL.
 *
 * Since there might be a lot of metadata, the calculator is provided with a
 * list of keys to track.  This list uses a default list of keys, but can be
 * adjusted after instantiation.
 *
 */

const DEFAULT_KEYS_TO_TRACK = [
  'extractedPdfTitle',
  'title',
  'extracted', // Flags if metadata has been extracted for this URL
  'faviconUrl',
  ...orderedCanonicalUrlTypes,

  // 'scrapedStudentCopy',
  // 'scrapedAttachment',
]
export class CanonicalUrlsRc extends RunningCalculator {
  data = {}

  // A less-efficient but faster in-memory map for constant-time lookups, this is not persisted
  inMemoryLookupMap = {}

  constructor(storageObj) {
    super('canonicalUrlsRc', ['browserRc'])
    this.data = Object.keys(storageObj?.data || {}).reduce((acc, key) => {
      acc[key] = new Set(storageObj.data[key])
      return acc
    }, {})
    // Build the in-memory lookup map
    this.inMemoryLookupMap = {}
    const canonicalUrls = Object.keys(this.data)
    for (const canonicalUrl of canonicalUrls) {
      for (const rawUrl of this.data[canonicalUrl]) {
        this.inMemoryLookupMap[rawUrl] = canonicalUrl
      }
    }
  }

  toJson() {
    return {
      ...super.toJson(),
      data: Object.keys(this.data).reduce((acc, key) => {
        acc[key] = [...this.data[key]]
        return acc
      }, {}),
    }
  }

  transition(event, stateData) {
    let stateChanged = false

    const { secrets, keysDeleted, keysBlacklisted, browserRc, urlFilter } =
      stateData

    // We just want to check whether or not the tab's URL has a canonical
    // URL mapping at every step.
    if (!browserRc.focusedTabId) return false

    const tab = browserRc.tabs[browserRc.focusedTabId]
    if (
      tab &&
      tab.url &&
      tab.canonicalUrl &&
      this.inMemoryLookupMap[tab.url] !== tab.canonicalUrl
    ) {
      // Update the mapping
      this.inMemoryLookupMap[tab.url] = tab.canonicalUrl
      // Update the data store
      this.data[tab.canonicalUrl] ||= new Set()
      if (!this.data[tab.canonicalUrl].has(tab.url)) {
        this.data[tab.canonicalUrl].add(tab.url)
        stateChanged = true
      }
    }
    return stateChanged
  }

  getCanonicalUrl(secrets, url) {
    if (this.inMemoryLookupMap[url] && secrets?.[this.inMemoryLookupMap[url]]) {
      return secrets[this.inMemoryLookupMap[url]]
    }
  }
}
